module.exports = __webpack_public_path__ + "img/ge.ge948ba6b.svg";